import React, { createContext, useContext, useState, ReactNode } from "react";

type FileCenterContextType = {
  statusMessage: string;
  setStatusMessage: (msg: string) => void;
  isFileListLoading: boolean;
  setIsFileListLoading: (val: boolean) => void;
  folders: any[];
  setFolders: (folders: any[]) => void;
};

const FileCenterContext = createContext<FileCenterContextType | undefined>(undefined);

export const FileCenterProvider = ({ children }: { children: ReactNode }) => {
  const [statusMessage, setStatusMessage] = useState("");
  const [isFileListLoading, setIsFileListLoading] = useState(false);
  const [folders, setFolders] = useState<any[]>([]); // You can replace `any` with your folder type

  return (
    <FileCenterContext.Provider
      value={{ statusMessage, setStatusMessage, isFileListLoading, setIsFileListLoading, folders, setFolders }}
    >
      {children}
    </FileCenterContext.Provider>
  );
};

export const useFileCenterContext = (): FileCenterContextType => {
  const context = useContext(FileCenterContext);
  if (!context) {
    throw new Error("useFileCenterContext must be used within a FileCenterProvider");
  }
  return context;
};
